(function () {
  var popup = document.querySelector('[data-marlowe-signature-popup]');
  if (!popup) return;

  var storageKey = 'marloweSignaturePopupClosed';
  var closeButtons = popup.querySelectorAll('[data-marlowe-signature-popup-close]');
  var closeButton = popup.querySelector('.marlowe-signature-popup__close');
  var showTimer;

  try {
    if (window.sessionStorage.getItem(storageKey) === 'true') return;
  } catch (error) {
    // Continue without session storage if the browser blocks it.
  }

  function setClosed() {
    try {
      window.sessionStorage.setItem(storageKey, 'true');
    } catch (error) {
      // Nothing to persist when storage is unavailable.
    }
  }

  function closePopup() {
    setClosed();
    popup.classList.remove('is-visible');
    window.setTimeout(function () {
      popup.hidden = true;
    }, 280);
    document.removeEventListener('keydown', handleKeydown);
  }

  function handleKeydown(event) {
    if (event.key === 'Escape') {
      closePopup();
    }
  }

  function showPopup() {
    popup.hidden = false;
    window.requestAnimationFrame(function () {
      popup.classList.add('is-visible');
      document.addEventListener('keydown', handleKeydown);
      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  showTimer = window.setTimeout(showPopup, 4000);

  window.addEventListener('pagehide', function () {
    window.clearTimeout(showTimer);
  });
})();
